export default "__VITE_ASSET__BN4BkBNS__"